import { StyleProvider } from '@ant-design/cssinjs'
import { Render, Render as RenderShell } from '@micun/form'
import { APP_CODE } from '@micun/web-components'
import ComponentRender from '@micun/web-components/dist/components/Render'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import {
  GlobalMessage as CompGlobMessage,
  GlobalModal as CompGlobModal,
} from '@micun/web-components'
import { GlobalMessage } from 'components/GlobalMessage'
import { GlobalModal } from 'components/GlobalModal'
import { LayoutProvider } from 'components/Layout'
import 'const'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import { MessageProvider } from 'hooks'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { theme } from 'theme'
import './index.css'
import reportWebVitals from './reportWebVitals'
import { Router } from './router'

dayjs.locale('zh-cn')

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
const queryClient = new QueryClient()

root.render(
  <HelmetProvider>
    <LayoutProvider config={{ appCode: APP_CODE }}>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider locale={zhCN} theme={theme}>
          <StyleProvider hashPriority='high'>
            <MessageProvider>
              <Router />
              <ComponentRender />
              <Render />
              <RenderShell />
              <GlobalMessage />
              <GlobalModal />
              <CompGlobMessage />
              <CompGlobModal />
            </MessageProvider>
          </StyleProvider>
        </ConfigProvider>
      </QueryClientProvider>
    </LayoutProvider>
  </HelmetProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
